import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "leads",
    defaultRoutePath: "/opportunities/lead",
    menuItemScope: "operations",
    menuItemName: "lead",

    routes: [
        {
            path: "/opportunities/lead",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
